/**
 * Sets <html lang> and <html dir> for a language entry ({ code, dir }). A right-to-left language
 * such as Arabic switches the whole page direction (see styles/rtl.css for the layout rules).
 */
export const applyDocumentLanguage = ({ code, dir }) => {
    const root = document.documentElement;
    root.lang = code;
    root.dir = dir === 'rtl' ? 'rtl' : 'ltr';
};
